import React from 'react'

const AwardPass = () => {
  return (
    <div>AwardPass</div>
  )
}

export default AwardPass